"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatListApiUpdateObservable = void 0;
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatListApiUpdateObservable {
    constructor(chatsStorage, httpAdapter, organizationUser, userDirectory) {
        this.chatsStorage = chatsStorage;
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.userDirectory = userDirectory;
    }
    chatListUpdateListener(cb, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.groupEventKey)(this.organization.organizationId, groupType), (chatList) => {
            cb(chatList);
        });
    }
}
exports.GroupChatListApiUpdateObservable = GroupChatListApiUpdateObservable;
